<div class="row forms_area">
    <div class="progress">
        <div class="cicle_dotted" [ngClass]="{'form_valid': productsSelected}"><span *ngIf="productsSelected" class="material-symbols-outlined icon">
                check
            </span></div>
        <div class="line" *ngIf="decorativeLineVisible && requireShipping"></div>
    </div>
    <div class="card">
        <div class="card_header">
            <div class="row row_jc_space_btw row_ai_center">
                <p class="title fz_l fw_700">Товары</p>
                <div class="btn_container">
                    <button type="button" class="btn btn_cancel" (click)="clearAll()" *ngIf="order.products && order.products.length != 0">Очистить</button>
                </div>
            </div>
        </div>
        <div class="card_body">
            <div class="top_area_select row row_ai_center row_jc_center select_area"><ng-content></ng-content> 
                <label class="inp_group">
                    <div class="lbl">Выбрать валюту</div>
                        <select [(ngModel)]="order.currency" class="inp inp_currency" name="currency">
                            <option value="usd">$</option>
                            <option value="eur">€</option>
                        </select>
                </label></div>
            <div class="group" *ngIf="order.products && order.products.length != 0">
                <div class="row header_row fz_m">
                    <div class="col-5">Название</div>
                    <div class="col-4">Количество</div>
                    <div class="col-5">Цена (за единицу)</div>
                    <div class="col-4">Скидка</div>
                    <div class="col-4">Сумма</div>
                    <div class="col-2"></div>
                </div>
                <div class="row row_ai_center body_row fz_s" *ngFor="let product of order.products">
                    <div class="col-5">{{ product.name }}</div>
                    <div class="col-4">
                        <app-quantity (quantityChange)="onQuantityChange($event, product)"></app-quantity>
                    </div>
                    <div class="col-5">{{order.currency == 'usd' ? '$' : '€'}}{{ product.price }}</div>
                    <div class="col-4 discount row row_ai_center">
                        {{order.currency == 'usd' ? '$' : '€'}}<input (input)="getTotalPrice()" min="0" type="number" name="discount" class="inp"
                            [(ngModel)]="product.discount">
                    </div>
                    <div class="col-4">{{order.currency == 'usd' ? '$' : '€'}}{{ getTotalPrice(product) }}</div>
                    <div class="col-2">
                        <button type="button" class="btn_red" (click)="removeProduct(product.productId)"><span
                                class="material-symbols-outlined color_red">
                                delete
                            </span></button>
                    </div>
                </div>
                <div class="row row_ai_center body_row fz_s">
                    <div class="col-5">Доставка</div>
                    <div class="col-4"></div>
                    <div class="col-5 discount row row_ai_center">{{order.currency == 'usd' ? '$' : '€'}}<input min="0" type="number" [(ngModel)]="shippingPrice" name="shippingPrice" class="inp"></div>
                    <div class="col-4 discount row row_ai_center">
                    </div>
                    <div class="col-4">{{order.currency == 'usd' ? '$' : '€'}}{{shippingPrice}}</div>
                    <div class="col-2">
                    </div>
                </div>
                <div class="total row fz_m fw_600">
                    <div class="col-17 text_align_r">Сумма:</div>
                    <div class="col-1"></div>
                    <div class="col-4">{{order.currency == 'usd' ? '$' : '€'}}{{ getOrderTotal() }}</div>
                    <div class="col-2"></div>
                </div>
            </div>
            <button class="btn dark_btn row fz_s fw_500 cursor_pointer" [disabled]="!order.products || order.products.length === 0" (click)="openNextStep()">{{requireShipping ? 'Дальше' : 'Готово'}}</button>
        </div>
    </div>
</div>